import automatedReportsSlice from './slice';

export const {
  fetchAllReports,
  fetchAllReportsError,
  fetchAllReportsSuccess,
  fetchLatestReportError,
  fetchLatestReport,
  fetchLatestReportSuccess,
  fetchLatestDashboardError,
  fetchLatestDashboard,
  fetchLatestDashboardSuccess,
  fetchReportSettingsError,
  fetchReportSettings,
  fetchReportSettingsSuccess,
  fetchSpecificReportError,
  fetchSpecificReport,
  fetchSpecificReportSuccess,
  fetchSpecificDashboardError,
  fetchSpecificDashboard,
  fetchSpecificDashboardSuccess,
  updateReportSettingsError,
  updateReportSettings,
  updateReportSettingsSuccess,
  fetchLatestReportByGroupError,
  fetchLatestReportByGroup,
  fetchLatestReportByGroupSuccess,
  fetchSpecificReportByGroupError,
  fetchSpecificReportByGroup,
  fetchSpecificReportByGroupSuccess,
  runAutomatedAuditError,
  runAutomatedAudit,
  runAutomatedAuditSuccess,
  fetchLatestReportRetry,
  automatedAuditStatusError,
  automatedAuditStatus,
  automatedAuditStatusSuccess,
  fetchTotalReports,
  fetchTotalReportsError,
  fetchTotalReportsSuccess,
  fetchResolvedReports,
  fetchResolvedReportsError,
  fetchResolvedReportsSuccess,
  setDefault,
  fetchAuditEngine,
  fetchAuditEngineSuccess,
  fetchAuditEngineError,
  fetchAuditLenghtError,
  fetchAuditLenght,
  fetchAuditLenghtSuccess,
  singlePageAudit,
  singlePageAuditError,
  singlePageAuditSuccess,
  reauditCriteriaPages,
  reauditCriteriaPagesError,
  reauditCriteriaPagesSuccess,
  _updateReportSettingsState
} = automatedReportsSlice.actions;
export default automatedReportsSlice.reducer;

export * from './types';
